module.exports = __webpack_public_path__ + "components/flag/static/square/mw-d1c07f18538bef28adfc32b3200f77ce.svg";